import { Suggestion as SuggestionFromApi, Product } from 'src/types';

export type HistoryItem = {
  type: 'history';
  __typename: 'history';
  text: string;
  navId: number;
};

export type OriginalItem = {
  type: 'original';
  __typename: 'original';
  text: string;
  navId: 0;
};

export enum SuggestionTypeEnum {
  SUGGESTED_PRODUCT = 'SuggestedProduct',
  SUGGESTED_PRODUCT_COLLECTION = 'SuggestedProductCollection',
  SUGGESTED_CATEGORY = 'SuggestedCategory',
  SUGGESTED_VIRTAL_CATEGORY = 'SuggestedVirtualCategory',
  SUGGESTED_SEARCH_PHRASE = 'SuggestedSearchPhrase',
  SUGGESTED_BRAND = 'SuggestedBrand',
  SUGGESTED_STOP = 'SuggestedShop',
  SUGGESTED_LANDING_PAGE = 'SuggestedLandingPage',
}

export type SuggestionType = typeof SuggestionTypeEnum[keyof typeof SuggestionTypeEnum];

export type Suggestion =
  | (SuggestionFromApi & {
      navId: number;
      type: SuggestionType;
    })
  | HistoryItem
  | OriginalItem;

export type ClickHandler = (s: Suggestion, i: number) => void;

export type ThinProduct = Pick<Product, 'id' | 'priceSummary'>;

export const SUGGESTION_ORDER = {
  SuggestedProduct: 2,
  SuggestedBrand: 1,
  SuggestedProductCollection: 1,
  SuggestedCategory: 1,
  SuggestedVirtualCategory: 1,
  SuggestedSearchPhrase: 1,
  SuggestedShop: 1,
  SuggestedLandingPage: 1,
};
